module.exports = {
  apiUrl: process.env.REACT_APP_API_URL,
  localUrl: process.env.REACT_APP_LOCAL_URL,
  ssoApi: process.env.REACT_APP_SSO_API,
  ssoUrl: process.env.REACT_APP_SSO_URL,
  auth: {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: 'Bearer 3ecd8fae-a11c-4561-9d53-824148b2fb13',
    },
  },
};
